module.exports = __webpack_public_path__ + "static/media/tipo_poliza.a1e91a16.svg";